$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-element-variants').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});




$(document).on("click", ".el-element-variant", function(e) {
$(this).parents('.el-product').find('.el-element-variant').removeClass('el-active');
$(this).addClass('el-active');
var variant_id = $(this).attr('variant_id');
$(this).parents('.el-product').find('.el-variant-trigger').hide().removeClass('active');
$(this).parents('.el-product').find('.el-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('active');
$('.el-checkout-button').attr('variant_id',variant_id);
var text = $(this).find('.el-variant-title').text();
$('.el-sticky-title').text(text);
});












$(document).on("click", ".el-cart-button", function (e) {
   openCart();
});





$(document).on("click", ".el-pdp-loops-tab-item", function (e) {
    $('.el-pdp-loops-tab-item').removeClass('el-active');
    $(this).addClass('el-active');
    var index = $(this).index();
    $('.el-pdp-loops-list1-item').removeClass('el-active');
    $('.el-pdp-loops-list1-item').eq(index).addClass('el-active');
});



document.addEventListener("cart:updated", ({ detail: { items } }) => {

    const totalQuantity = items.reduce((sum, item) => {
        return sum + item.quantity;
    }, 0);

    document.querySelectorAll('.el-cart-count').forEach(element => {

        if (totalQuantity > 0) {
            element.textContent = totalQuantity;
            element.style.display = '';
        } else {
            element.textContent = '0';
            element.style.display = 'none';
        }

    });

});





function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-pdp-weeks-list1-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
});